import { CCard } from '@coreui/react-pro';
import GoogleConnect from './GoogleConnect';

const GoogleReconnect = () => {
    return (
        <div className="f centered fw-w mt-32">
            <CCard className="p-24">
                <div className="f fb-100">
                    Cliquez sur le bouton ci-dessous pour vous reconnecter et mettre à jour vos permissions Google :{' '}
                </div>
                <GoogleConnect />
            </CCard>
        </div>
    );
};

export default GoogleReconnect;
